import { render, staticRenderFns } from "./PageTreeItem.vue?vue&type=template&id=092a18a4&scoped=true&"
import script from "./PageTreeItem.vue?vue&type=script&lang=js&"
export * from "./PageTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./PageTreeItem.vue?vue&type=style&index=0&id=092a18a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092a18a4",
  null
  
)

export default component.exports